import script from "./TalkToTextPopover.vue?vue&type=script&setup=true&lang=js"
export * from "./TalkToTextPopover.vue?vue&type=script&setup=true&lang=js"

import "./TalkToTextPopover.vue?vue&type=style&index=0&id=70cbb83e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70cbb83e"]])

export default __exports__